/**
 * 路由配置
 *
 * constantRoutes: 固定路由，所有用户都可访问
 * demoRoutes: 演示路由，仅在 development 环境加载，不需要权限控制
 * 动态路由: 根据用户权限从后端获取并动态加载
 */
import type { RouteRecordRaw } from "vue-router";

/**
 * 404 路由（必须放在最后）
 * 动态路由加载后会添加这个路由
 */
export const notFoundRoute: RouteRecordRaw = {
  path: "/:pathMatch(.*)*",
  redirect: "/404",
  meta: {
    hidden: true,
  },
};
